import FormControl from "./FormControl";
import Select from "./Select";

const Inputs = {
  FormControl,
  Select,
};

export default Inputs;
